export default __webpack_public_path__ + "static/sampling-config-3d55131e97e6d523caa0449f6e4ee3d1.png";